import { withSection } from "./Section";
import EventSlider, {
  EventSliderProps,
  filteredAndSortedEvents
} from "../EventSlider";

const EventSliderSection = withSection<EventSliderProps>(
  EventSlider,
  null,
  p => filteredAndSortedEvents(p.events).length === 0
);
export default EventSliderSection;
